import Button from "@components/Button"
import getPriceForCurrency from "@helpers/getPriceForCurrency"
import { Form } from "react-router-dom"
import { Plan, StripePrice } from "src/types"

interface Props {
  buttonClassName?: string
  buttonTitle: string
  currency: string
  fullPrice: StripePrice | undefined
  isSubmitting: boolean
  plan: Plan
  priceId: string | undefined
  setIsSubmitting: (isSubmitting: boolean) => void
}

export default function SubscriptionForm({
  buttonClassName = "",
  buttonTitle,
  currency,
  fullPrice,
  isSubmitting,
  plan,
  priceId,
  setIsSubmitting,
}: Props) {
  const handleClick = () => {
    setIsSubmitting(true)
  }

  const priceForCurrency = getPriceForCurrency(fullPrice, currency)

  const fullPriceAmount =
    priceForCurrency?.price ?? fullPrice?.unit_amount_decimal

  return (
    <Form onSubmit={handleClick} method="post">
      <input type="hidden" name="currency" value={currency} />
      <input type="hidden" name="fullPrice" value={fullPriceAmount} />
      <input type="hidden" name="nextPriceId" value={fullPrice?.id} />
      <input type="hidden" name="plan" value={plan} />
      <input type="hidden" name="priceId" value={priceId} />

      <Button
        className={buttonClassName}
        disabled={isSubmitting}
        title={buttonTitle}
        type="submit"
      />
    </Form>
  )
}
